'use-strict';
const { isset } = require('@hints/utils/data');
/**
 * @typedef {object} TesterData
 * @property {number} weight
 * @property {number} height
 * @property {number} neck
 * @property {number} age
 * @property {'ms' | 'mr'} gender
 */

module.exports = class Protocol {
    /**
     * @param {any} evaluation
     * @param {TesterData} tester 
     * @param {any} data
     * @returns {{
     *  logs?: any,
     *  data?: Record<string, any> & { score: number }
     * }} data
     */
    getScore(evaluation, tester, data) {
        return {
            logs: null,
            data: {
                score: 0,
            }
        };
    }

    validateResults(body) {
        if(!isset(body)) return false;
        if(!isset(body.score)) return false;
        if(body.score < 0 || body.score > 100) return false;
        return true;
    }
};